<div id="sub-header" class="data-rules" [ngClass]="extraEntitiesExpanded ? 'expanded' : ''">
  <nav [ngClass]="!this.metaLoaded || !this.rulesLoaded ? 'not-loaded' : 'loaded'">
    <h2>Select entity <span class="green"></span></h2>
    <app-skeleton *ngIf="!this.metaLoaded || !this.rulesLoaded" [style]="'tab-filter-buttons'" [flex]="true" [gap]="12" [count]="5"></app-skeleton> <!-- Up the count if we start seeing lots more -->
    <mat-button-toggle-group *ngIf="this.metaLoaded && this.rulesLoaded" name="selectEntity" aria-label="Select entity buttons" hideSingleSelectionIndicator="true">
      <section class="core-entities">
        <!-- TODO: Break out into component to avoid duplication -->
        <mat-button-toggle *ngFor="let entity of coreEntities | keyvalue: shiftLeadButton.bind(this)"
                           (change)="onEntityClicked(entity.key)"
                           [checked]="entity.key === selectedEntity"
                           [ngClass]="[entity.key === selectedEntity ? 'selected': '',
                                       entitySelectorsMap[entity.key] ? entitySelectorsMap[entity.key] + '-entity' : '']">
          <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
          {{entityMap[entity.key]}}
          <aside>{{entity.value}}</aside>
        </mat-button-toggle>
        <span *ngIf="!extraEntitiesExpanded" (click)="extraEntitiesExpanded = !extraEntitiesExpanded" class="entity-label-link">View all entities</span>
        <span *ngIf="extraEntitiesExpanded" class="entity-label">Core entities</span>
      </section>
      <aside>
        <section class="file-attachment-entities">
          <mat-button-toggle *ngFor="let entity of fileAttachmentEntities | keyvalue"
                             (change)="onEntityClicked(entity.key)"
                             matTooltip="{{entityMap[entity.key]}}"
                             [ngClass]="[entity.key === selectedEntity ? 'selected': '',
                                       entitySelectorsMap[entity.key] ? entitySelectorsMap[entity.key] + '-entity' : '']">
            <i class="bhi-attach"></i>
            {{entityMap[entity.key] | TransformFileAttachment}}
            <aside>{{entity.value}}</aside>
          </mat-button-toggle>
          <span class="entity-label"><i class="bhi-attach"></i> File attachment entities</span>
        </section>
        <section class="additional-entities">
          <ngx-skeleton-loader *ngIf="!this.metaLoaded || !this.rulesLoaded" appearance="circle" class="sub-header-btn"
                               count="4" animation="progress"></ngx-skeleton-loader>
          <mat-button-toggle *ngFor="let entity of additionalEntities | keyvalue"
                             (change)="onEntityClicked(entity.key)"
                             [ngClass]="[entity.key === selectedEntity ? 'selected': '',
                                         entitySelectorsMap[entity.key] ? entitySelectorsMap[entity.key] + '-entity' : '']">
            <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
            {{entityMap[entity.key]}}
            <aside>{{entity.value}}</aside>
          </mat-button-toggle>
        </section>
        <section class="custom-object-entities">
          <ngx-skeleton-loader *ngIf="!this.metaLoaded || !this.rulesLoaded" appearance="circle" class="sub-header-btn"
                               count="4" animation="progress"></ngx-skeleton-loader>
          <mat-button-toggle *ngFor="let entity of customObjectEntities | keyvalue"
                             (change)="onEntityClicked(entity.key)"
                             [ngClass]="[entity.key === selectedEntity ? 'selected': '',
                                       entitySelectorsMap[entity.key] ? entitySelectorsMap[entity.key] + '-entity' : '']">
            <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
            {{entityMap[entity.key]}}
            <aside>{{entity.value}}</aside>
          </mat-button-toggle>
          <span class="entity-label">Custom object entities</span>
        </section>
      </aside>
    </mat-button-toggle-group>
  </nav>
  <div (click)="extraEntitiesExpanded = !extraEntitiesExpanded" class="plus-more" id="all-entities-dropdown-arrow"><i class="bhi-sort-asc"></i></div>
</div>
<div class="content">
  <article>
    <h2 id="header-grid" class="heading-underline">Select or create rules for which Bullhorn values you would like to
      modify
      <aside *ngIf="this.metaLoaded && this.rulesLoaded" id="sub-info">
        <button class="{{entitySelectorsMap[selectedEntity] | lowercase}}-entity new-rule" type="button"
                theme="sub-info"
                (click)="addNewRule()" [disabled]="newRuleButtonsDisabled">
          New <span>{{entityMap[selectedEntity]}}</span> Rule <i class="bhi-add-thin"></i>
        </button>
      </aside>
    </h2>
    <ul id="rules">
      <app-skeleton *ngIf="!this.metaLoaded || !this.rulesLoaded" [style]="'medium-row-table'" [count]="5"></app-skeleton>
      <li *ngIf="dataRulesDataService.allRules.length > 0 && dataRules.length === 0" class="no-results">
        No rules found for this entity, please create one below
      </li>
      <li *ngFor="let rule of dataRules; let i = index" @transitionNewRowInOut>
        <app-rule id="{{selectedEntity}}-row-{{i}}"
                  [dataRule]="rule"
                  [ruleIndex]=i
                  [currentRuleExamples]="currentRuleExamples"
                  (currentRuleExamplesChange)="currentRuleExamples=$event"
                  [selectedEntity]="selectedEntity"
                  [tasksRunning]="tasksRunning" [entityMap]="entityMap"
                  (ruleSavedEmitter)="ruleSaved = $event"
                  [savedRuleEvent]="savedRuleEvent"
                  (ruleClickEventEmitter)="onRuleClicked(rule.ruleData.id)"
        ></app-rule>

        <app-rule-schedule *ngIf="rule.viewState.scheduleOpen" [dataRule]="rule"
                           (scheduleSaving)="saveSchedule($event, i)"
                           (scheduleDeleting)="deleteSchedule(i)"
                           [isRuleFirstInAChain]="isRuleFirstInAChain.bind(this)">
        </app-rule-schedule>
        <div class="action-icons">
          <!-- ChainGroup icon block -->
          <span class="chained icon-container" *ngIf="isRuleInAChain(rule.ruleData.id)"
                [appCustomOverlayTriggerFor]="ruleInChainInfo"
                [shouldClose]="shouldRuleChainInfoClose"
          >
            <span class="action-icon-text" matTooltip="Rule chained">CHAINED</span>
            <i [ngClass]="{'material-icons notranslate chain-group-icon': true}"
               tabindex="0">playlist_play</i>
              <app-rule-in-chain-screen
                #ruleInChainInfo
                [ruleId]="rule.ruleData.id"
                [overlayPositioningConfig]="ruleInChainOverlayPositioningConfig"
                [navigateToDataRules]="navigateToDataRules.bind(this)"
              ></app-rule-in-chain-screen>
          </span>
          <!-- Schedule icon block -->
          <span class="schedule icon-container" *ngIf="schedulingEnabled && !utilsService.compareInternalDataRuleIds(rule.ruleData.id, 0)">
             <ng-container
               *ngIf="isRuleInAChain(rule.ruleData.id) ? this.isRuleFirstInAChain(rule.ruleData.id) : true; else schedulingDisabled">
              <ng-container *ngIf="!isRuleEnrichBlocked(rule); else enrichCreditBlockedSchedule">
               <span
                *ngIf="ruleSchedule(rule.ruleData.id) && !this.ruleSchedule(rule.ruleData.id)?.isExpired && !rule.viewState.scheduleSaving"
                class="scheduled" (click)="openScheduled(i)">
                <span class="action-icon-text" matTooltip="Rule scheduled">SCHEDULED</span>
                <i class="material-icons notranslate schedule-icon green" matTooltip="Rule scheduled">alarm_on</i>
              </span>
              <span
                *ngIf="(!ruleSchedule(rule.ruleData.id) || this.ruleSchedule(rule.ruleData.id)?.isExpired) && !rule.viewState.scheduleSaving"
                class="scheduled" (click)="openScheduled(i)">
                <i class="material-icons notranslate schedule-icon" matTooltip="Schedule when to automatically run {{rule.ruleData.name}}">alarm</i>
              </span>
            <span *ngIf="rule.viewState.scheduleSaving" class="saving spinner-border spinner-border-sm"
                  [matTooltip]="deletingSchedule ? 'Removing schedule' : 'Saving schedule'"></span>
              </ng-container>
              <ng-template #enrichCreditBlockedSchedule>
                <span>
                  <i [attr.aria-disabled]="'true'" class="material-icons notranslate credit-blocked-icon"
                     [matTooltip]="enrichCreditBlockedTooltip" matTooltipPosition="left">alarm_off</i>
                </span>
              </ng-template>
            </ng-container>
            <ng-template #schedulingDisabled>
              <span>
                <i disabled="true" class="material-icons notranslate" matTooltip="Rule in Chained Rule Group">alarm_off</i>
              </span>
            </ng-template>

          </span>
          <span class="icon-container"
                [matTooltip]="rule.viewState.dirty ? 'Rule needs saving before duplicating' : 'Duplicate ' + rule.ruleData.name" matTooltipPosition="left">
            <i class="material-icons copy-icon notranslate"
               [ngClass]="{'disabled': rule.viewState.dirty}"
               (click)="duplicateRule(i)">content_copy</i>
          </span>
          <i matTooltip="Delete {{rule.ruleData.name}}" class="bhi-delete-o" (click)="deleteRule(i)"></i>
          <span class="icon-container"
                [class.icon-container--blocked]="isRuleEnrichBlocked(rule)"
                [matTooltip]="rule.viewState.dirty ? 'Rule needs saving before running' : isRuleEnrichBlocked(rule) ? enrichCreditBlockedTooltip : 'View results for ' + rule.ruleData.name" matTooltipPosition="left">
            <i class="material-icons notranslate" (click)="viewExamplesForRule(i, rule.ruleData.id);"
               [ngClass]="{'disabled': rule.viewState.dirty || isRuleEnrichBlocked(rule)}">play_arrow</i>
          </span>
          <i matTooltip="Expand/Collapse {{rule.ruleData.name}}" matTooltipPosition="left"
             [ngClass]="{'expanded': rule.viewState.expanded}" class="bhi-sort-desc"
             (click)="onRuleClicked(rule.ruleData.id)"></i>
        </div>
      </li>
    </ul>
    <section *ngIf="this.metaLoaded && this.rulesLoaded" class="footer-btns stretch-btns">
      <button id="bottom-create-rule-button" theme="nav" class="{{entitySelectorsMap[selectedEntity]}}-entity"
              (click)="addNewRule()" [disabled]="newRuleButtonsDisabled" appRipple>
        <span>New <span class="entity-text">{{entityMap[selectedEntity]}}</span> Rule <i
          class="bhi-add-thin"></i></span>
      </button>
    </section>
  </article>
</div>

<app-loading-snackbar></app-loading-snackbar>
